import { enableFortisPG } from "handlers/features";
import { getLocaleString } from "utils/localization/locale";

// Payment constants
export const DEFAULT_PAYMENT_TYPE = "PAYMENT";

export const getPaymentActionColumnLabel = () =>
  enableFortisPG()
    ? getLocaleString("payments.refund_void", "Refund / Void")
    : getLocaleString("payments.refund", "Refund");
